(function($, w, undefined) {

    function GlobalHeader(args) {
        console.log('global header starts');

        this.defaults = {
            parent: '#global-header',
            btnOffCanvas: '.btn-offcanvas'
        };

        this.options = $.extend(true, {}, this.defaults, args);
        this.$parent = $(this.options.parent);
        this.$body = $("body");

        if (!this.$parent) {
            return;
        }

        this.$btnOffCanvas = this.parent(this.options.btnOffCanvas);
        this.bindEvents();
    }

    GlobalHeader.prototype.parent = function(selector) {
        return $(selector, this.$parent);
    };

    GlobalHeader.prototype.toggleClasses = function (self) {

        console.log('toggle classes');

        //Toggle button
        if (self.$btnOffCanvas.hasClass('nav-open')) {
            self.$btnOffCanvas.removeClass('nav-open');
        } else {
            self.$btnOffCanvas.addClass('nav-open');
        }

        //Toggle body element; used for fixing nav and overflow
        if (self.$body.hasClass('nav-open')) {
            self.$body.removeClass('nav-open');
        } else {
            self.$body.addClass('nav-open');
        }


    };

    GlobalHeader.prototype.bindEvents = function (){
        var self = this;
        console.log('bind events');

        var globalNav = new MCN.GlobalNav();

        this.$btnOffCanvas.on('click', function(){
            console.log('click button oncanvas');
            globalNav.toggleNav();
            //MCN.GlobalNav().toggleNav();
            self.toggleClasses(self);
        });
        console.log('global header');
    };


    w.MCN = w.MCN || {};
    w.MCN.GlobalHeader = GlobalHeader;

})(jQuery, window);
